import React from 'react';
import {
  Box, Container, Grid, Skeleton, Stack,
} from '@mui/material';
import { TripMatchDetailCard } from '@marageti/z4-lib';
import TravelerCard from '../../../components/traveler-card';
import { ViewProps } from './types';
import Alerts from './alerts';
import TripRequestDetailCard from '../../../components/trip-request-details/trip-request-card';
import { RequestReview } from '../../../components/trip-match-alerts';
import TripMatchSalesCard from '../../../components/trip-match-sales';
import { shouldShowSalesCard } from '../../../utils/trip-matches';
import TravelerProfileNotesSection from '../../../components/traveler-profile-notes';
import TripRequestMatchingNotes from '../../../components/trip-request-matching-notes';

const DetailsView = ({
  loading,
  travelerId,
  travelers,
  tripMatch,
  tripRequest,
  showRequestReview,
  onNotesEdit,
  onTravelerEdit,
  onReviewSent,
  loggedInTeamMember,
}: ViewProps) => (
  <Container maxWidth="lg">
    <Box sx={{
      pt: 4,
      pb: 15,
    }}
    >
      {tripMatch && showRequestReview && (
        <Box sx={{ mb: 3 }}>
          <RequestReview
            reviewRequestHidden={tripRequest?.visibilityFlags.hideReviewRequest || false}
            tripMatchId={tripMatch.id}
            onReviewSent={onReviewSent}
          />
        </Box>
      )}
      <Grid container spacing={3}>
        <Grid item xs={12} lg={5}>
          <Stack spacing={3}>
            {!loading ? (
              <TravelerCard
                travelers={travelers || []}
                tripRequest={tripRequest}
                onEditProfile={onTravelerEdit}
                onEditEmail={onTravelerEdit}
              />
            ) : (<Skeleton variant="rounded" height={296} />)}
            {travelerId ? (
              <TravelerProfileNotesSection travelerId={travelerId} />
            ) : (
              <Skeleton variant="rounded" height={160} />
            )}
          </Stack>
        </Grid>

        <Grid item xs={12} lg={7}>
          <Stack spacing={3}>

            {tripMatch && <Alerts status={tripMatch.status} statusInfo={tripMatch.statusInfo} />}

            {tripMatch ? (
              <TripMatchDetailCard
                title="Match Details"
                tripMatch={tripMatch}
              />
            ) : (
              <Skeleton variant="rounded" height={616} />
            )}

            {tripMatch && shouldShowSalesCard(tripMatch) && (
            <TripMatchSalesCard
              tripMatch={tripMatch}
            />
            )}

            {!loading ? (
              <TripRequestDetailCard title="Original Request" tripRequest={tripRequest!} displayExternalLink loggedInTeamMember={loggedInTeamMember} />
            ) : (
              <Skeleton variant="rounded" height={616} />
            )}

            {!loading ? (
              <TripRequestMatchingNotes
                tripRequest={tripRequest}
                onEditSuccess={onNotesEdit}
              />
            ) : (
              <Skeleton variant="rounded" height={616} />
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  </Container>
);

export default DetailsView;
